/* 3DMint theme — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};

  /* ---------- Helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '{{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(match[0], value);
  }
  theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(message, isError) {
    var toast = qs('#CartToast');
    if (!toast) return;
    qs('[data-toast-msg]', toast).textContent = message;
    toast.classList.toggle('is-error', !!isError);
    qs('.toast__link', toast).hidden = !!isError;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) {
      var t = qs('#CartToast');
      if (t) t.hidden = true;
    }
  });

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = qs('#MenuDrawer');
    if (!drawer) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      qsa('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var closeBtn = qs('[data-drawer-close]', drawer);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
      qsa('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }
    qsa('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    qsa('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Search toggle ---------- */
  function initSearch() {
    qsa('[data-search-toggle]').forEach(function (btn) {
      var bar = document.getElementById(btn.getAttribute('aria-controls'));
      if (!bar) return;
      btn.addEventListener('click', function () {
        var willOpen = bar.hidden;
        bar.hidden = !willOpen;
        btn.setAttribute('aria-expanded', String(willOpen));
        if (willOpen) {
          var input = qs('input[type="search"]', bar);
          if (input) input.focus();
        }
      });
    });
  }

  /* ---------- Desktop dropdown: close others / outside click ---------- */
  function initDropdowns() {
    document.addEventListener('click', function (e) {
      qsa('details[data-dropdown][open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      qsa('details[data-dropdown][open]').forEach(function (d) {
        d.removeAttribute('open');
        var s = qs('summary', d);
        if (s) s.focus();
      });
    });
  }

  /* ---------- Product page ---------- */
  function ProductSection(root) {
    this.root = root;
    this.form = qs('form[data-product-form]', root);
    if (!this.form) return;
    var dataEl = qs('[data-product-json]', root);
    this.data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [] };
    this.idInput = qs('input[name="id"]', this.form);
    this.atc = qs('[data-atc]', root);
    this.atcLabel = this.atc ? this.atc.getAttribute('data-label') : 'Add to cart';
    this.buyNow = qs('[data-buy-now]', root);
    this.errorEl = qs('[data-form-error]', root);
    this.track = qs('[data-gallery-track]', root);
    this.initVariants();
    this.initGallery();
    this.initPersonaliser();
    this.initQty();
    this.initSubmit();
    this.initSticky();
  }

  ProductSection.prototype.formElements = function () {
    var formId = this.form.id;
    return qsa('input, select, textarea', document).filter(function (el) {
      return el.form && el.form.id === formId;
    });
  };

  /* Variants */
  ProductSection.prototype.initVariants = function () {
    var self = this;
    this.optionInputs = qsa('[data-option-index]', this.root);
    if (!this.optionInputs.length) return;
    this.root.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-option-index')) self.onOptionChange();
    });
    this.updateAvailability();
  };

  ProductSection.prototype.selectedOptions = function () {
    var opts = [];
    this.optionInputs.forEach(function (input) {
      var i = parseInt(input.getAttribute('data-option-index'), 10);
      if ((input.type === 'radio' && input.checked) || input.tagName === 'SELECT') opts[i] = input.value;
    });
    return opts;
  };

  ProductSection.prototype.findVariant = function (opts) {
    return this.data.variants.filter(function (v) {
      return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
    })[0];
  };

  ProductSection.prototype.onOptionChange = function () {
    var opts = this.selectedOptions();
    var variant = this.findVariant(opts);
    qsa('[data-selected-option]', this.root).forEach(function (el) {
      var i = parseInt(el.getAttribute('data-selected-option'), 10);
      el.textContent = opts[i] || '';
    });
    this.updateAvailability();
    if (!variant) {
      this.setButtons(false, 'Unavailable');
      return;
    }
    this.idInput.value = variant.id;
    this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    this.setButtons(variant.available, variant.available ? this.atcLabel : 'Sold out');
    this.updatePrice(variant);
    if (variant.media_id) this.goToMedia(variant.media_id);
    if (window.history && window.history.replaceState && this.data.url) {
      window.history.replaceState({}, '', this.data.url + '?variant=' + variant.id);
    }
  };

  /* Mark option values that don't exist with the other current selections */
  ProductSection.prototype.updateAvailability = function () {
    var self = this;
    var opts = this.selectedOptions();
    this.optionInputs.forEach(function (input) {
      if (input.type !== 'radio') return;
      var i = parseInt(input.getAttribute('data-option-index'), 10);
      var test = opts.slice();
      test[i] = input.value;
      var match = self.data.variants.some(function (v) {
        return v.available && v.options.every(function (o, j) { return test[j] === undefined || o === test[j]; });
      });
      var label = input.nextElementSibling;
      if (label) label.classList.toggle('is-unavailable', !match);
      if (label) label.style.opacity = match ? '' : '.5';
    });
  };

  ProductSection.prototype.setButtons = function (enabled, label) {
    var targets = qsa('[data-atc], [data-sticky-atc]', this.root);
    targets.forEach(function (b) {
      b.disabled = !enabled;
      var text = qs('[data-atc-text]', b);
      if (text) text.textContent = label;
    });
    if (this.buyNow) this.buyNow.disabled = !enabled;
  };

  ProductSection.prototype.updatePrice = function (v) {
    qsa('[data-price]', this.root).forEach(function (el) {
      var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      if (sale) {
        var pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
        html += '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + formatMoney(v.compare_at_price) + '</s>';
        html += '<span class="price__badge">' + pct + '% OFF</span>';
      }
      var wrap = qs('.price', el);
      if (wrap) {
        wrap.innerHTML = html;
        wrap.classList.toggle('price--sale', !!sale);
      }
    });
  };

  /* Gallery */
  ProductSection.prototype.initGallery = function () {
    var self = this;
    if (!this.track) return;
    this.slides = qsa('[data-media-id]', this.track);
    var thumbs = qsa('[data-thumb]', this.root);
    var dots = qsa('[data-dot]', this.root);
    function setCurrent(index) {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === index)); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === index)); });
    }
    thumbs.concat(dots).forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.goToIndex(parseInt(btn.getAttribute('data-index'), 10));
      });
    });
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var w = self.track.clientWidth || 1;
        setCurrent(Math.round(self.track.scrollLeft / w));
        ticking = false;
      });
    }, { passive: true });
  };

  ProductSection.prototype.goToIndex = function (index) {
    if (!this.track || !this.slides[index]) return;
    this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  };

  ProductSection.prototype.goToMedia = function (mediaId) {
    if (!this.slides) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) {
        this.goToIndex(i);
        return;
      }
    }
  };

  /* Personaliser: live preview, counters, upload name */
  ProductSection.prototype.initPersonaliser = function () {
    var root = this.root;
    var preview = qs('[data-preview-text]', root);
    var self = this;

    function updatePreview() {
      if (!preview) return;
      var textInput = qs('[data-preview-source]', root);
      var fontInput = qs('[data-preview-font]:checked', root);
      var colorInput = qs('[data-preview-color]:checked', root);
      preview.textContent = textInput ? textInput.value.trim() : '';
      preview.style.fontFamily = fontInput ? fontInput.getAttribute('data-preview-font') : '';
      if (colorInput) {
        var c = colorInput.getAttribute('data-preview-color');
        preview.style.setProperty('--pv-color', c);
        preview.style.setProperty('--pv-glow', c);
      }
    }

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-preview-source')) {
        updatePreview();
        if (preview && t.value.length === 1) self.goToIndex(0);
      }
      if (t.hasAttribute('data-count')) {
        var counter = qs('[data-counter-for="' + t.id + '"]', root);
        if (counter) counter.textContent = t.value.length;
      }
      t.classList.remove('is-invalid');
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-preview-font') || t.hasAttribute('data-preview-color')) {
        updatePreview();
        if (preview) self.goToIndex(0);
      }
      if (t.hasAttribute('data-value-label')) {
        var out = qs('[data-value-for="' + t.name + '"]', root);
        if (out) out.textContent = t.value;
      }
      if (t.type === 'file') {
        var wrap = t.closest('.upload');
        var nameEl = wrap ? qs('[data-file-name]', wrap) : null;
        var file = t.files && t.files[0];
        var maxMb = parseFloat(t.getAttribute('data-max-mb') || '20');
        if (file && file.size > maxMb * 1024 * 1024) {
          t.value = '';
          if (nameEl) nameEl.textContent = nameEl.getAttribute('data-default');
          self.showError('That image is larger than ' + maxMb + ' MB. Please choose a smaller file.');
          return;
        }
        if (nameEl) nameEl.textContent = file ? file.name : nameEl.getAttribute('data-default');
        if (wrap) wrap.classList.remove('is-invalid');
      }
    });
    updatePreview();
  };

  /* Quantity */
  ProductSection.prototype.initQty = function () {
    qsa('[data-qty]', this.root).forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-qty-step') === 'up' ? 1 : -1;
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
        });
      });
    });
  };

  ProductSection.prototype.showError = function (msg) {
    if (this.errorEl) this.errorEl.textContent = msg || '';
  };

  ProductSection.prototype.validate = function () {
    var firstInvalid = null;
    this.formElements().forEach(function (el) {
      if (el.disabled || !el.willValidate) return;
      if (!el.checkValidity()) {
        if (!firstInvalid) firstInvalid = el;
        if (el.type === 'file') {
          var up = el.closest('.upload');
          if (up) up.classList.add('is-invalid');
        } else {
          el.classList.add('is-invalid');
        }
      }
    });
    if (firstInvalid) {
      var label = firstInvalid.id ? qs('label[for="' + firstInvalid.id + '"]') : null;
      var name = firstInvalid.getAttribute('data-field-name') || (label ? label.textContent : 'required fields');
      this.showError('Please fill in: ' + name.replace(/\s+/g, ' ').trim());
      var target = firstInvalid.type === 'file' || firstInvalid.type === 'radio' ? (firstInvalid.closest('.form-row') || firstInvalid.parentElement) : firstInvalid;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (firstInvalid.type !== 'file' && firstInvalid.type !== 'radio') {
        setTimeout(function () { firstInvalid.focus({ preventScroll: true }); }, 350);
      }
      return false;
    }
    this.showError('');
    return true;
  };

  ProductSection.prototype.buildFormData = function () {
    var raw = new FormData(this.form);
    var clean = new FormData();
    raw.forEach(function (value, key) {
      if (typeof value === 'string' && value.trim() === '') return;
      if (typeof File !== 'undefined' && value instanceof File && value.size === 0) return;
      clean.append(key, value);
    });
    return clean;
  };

  ProductSection.prototype.initSubmit = function () {
    var self = this;
    this.form.setAttribute('novalidate', 'novalidate');
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addToCart(false);
    });
    if (this.buyNow) {
      this.buyNow.addEventListener('click', function (e) {
        e.preventDefault();
        self.addToCart(true);
      });
    }
  };

  ProductSection.prototype.addToCart = function (goToCheckout) {
    var self = this;
    if (!this.validate()) return;
    var btn = goToCheckout ? this.buyNow : this.atc;
    if (btn) btn.classList.add('is-loading');
    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: this.buildFormData()
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var msg = res.json.description || res.json.message || 'Could not add to cart. Please try again.';
          self.showError(msg);
          showToast(msg, true);
          return;
        }
        if (goToCheckout) {
          window.location.href = (routes.root || '/').replace(/\/?$/, '/') + 'checkout';
          return;
        }
        if (theme.cartType === 'page') {
          window.location.href = routes.cart || '/cart';
          return;
        }
        refreshCartCount();
        showToast((res.json.product_title || 'Item') + ' added to cart');
      })
      .catch(function () {
        self.showError('Network error. Please check your connection and try again.');
      })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  };

  /* Sticky add to cart (mobile) */
  ProductSection.prototype.initSticky = function () {
    var sticky = qs('[data-sticky-bar]', this.root);
    var self = this;
    if (!sticky || !this.atc || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', !e.isIntersecting && passed);
    });
    io.observe(this.atc);
    var stickyBtn = qs('[data-sticky-atc]', sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { self.addToCart(false); });
    }
  };

  /* ---------- Product recommendations (lazy) ---------- */
  function initRecommendations() {
    qsa('[data-recommendations]').forEach(function (el) {
      var load = function () {
        fetch(el.getAttribute('data-url'))
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var tmp = document.createElement('div');
            tmp.innerHTML = text;
            var fresh = qs('[data-recommendations]', tmp);
            var section = el.closest('.shopify-section');
            if (fresh && fresh.innerHTML.trim().length && qs('.card', fresh)) {
              el.innerHTML = fresh.innerHTML;
            } else if (section && !window.Shopify?.designMode) {
              section.remove();
            }
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          if (entries[0].isIntersecting) { obs.disconnect(); load(); }
        }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(el);
      } else {
        load();
      }
    });
  }

  /* ---------- Collection filters ---------- */
  function initFilters() {
    qsa('[data-filter-form]').forEach(function (form) {
      var timer;
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return;
        form.submit();
      });
      form.addEventListener('input', function (e) {
        if (e.target.type !== 'number') return;
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 900);
      });
    });
  }

  /* ---------- Cart page ---------- */
  function initCartPage() {
    var form = qs('[data-cart-form]');
    if (!form) return;
    var timer;
    qsa('[data-cart-qty]', form).forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-qty-step') === 'up' ? 1 : -1;
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          clearTimeout(timer);
          timer = setTimeout(function () { form.submit(); }, 500);
        });
      });
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 300);
      });
    });
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery() {
    qsa('[data-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var max = parseInt(el.getAttribute('data-max'), 10) || min;
      if (max < min) max = min;
      var skipSunday = el.getAttribute('data-skip-sunday') === 'true';
      function addDays(days) {
        var d = new Date();
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (skipSunday && d.getDay() === 0) continue;
          added++;
        }
        return d;
      }
      var fmt = { weekday: 'short', day: 'numeric', month: 'short' };
      var a = addDays(min).toLocaleDateString('en-IN', fmt);
      var b = addDays(max).toLocaleDateString('en-IN', fmt);
      var out = qs('[data-delivery-date]', el);
      if (out) out.textContent = min === max ? a : a + ' – ' + b;
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initDelivery();
    initDrawer();
    initSearch();
    initDropdowns();
    qsa('[data-product-section]').forEach(function (el) {
      if (!el.__product) el.__product = new ProductSection(el);
    });
    initRecommendations();
    initFilters();
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-init a section after it is edited */
  document.addEventListener('shopify:section:load', function (e) {
    var el = qs('[data-product-section]', e.target);
    if (el) el.__product = new ProductSection(el);
    initDelivery();
    initRecommendations();
    initDrawer();
  });
})();
